// components/BreadcrumbHeader.js
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThLarge, faChevronDown, faCheck, faList } from '@fortawesome/free-solid-svg-icons';

const BreadcrumbCatalogos = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    
    const catalogos = [
        { path: '/usuarios', label: 'Usuarios', icon: '👥', color: '#3498db' },
        { path: '/motivos', label: 'Motivos', icon: '📋', color: '#e74c3c' },
        { path: '/segmentos', label: 'Segmentos', icon: '📊', color: '#2ecc71' },
        { path: '/porcentajes', label: 'Porcentajes', icon: '📈', color: '#f39c12' },
    ];
    const currentPath = location.pathname;
    const currentCatalogo = catalogos.find(cat => currentPath.includes(cat.path)) || catalogos[0];
   return (
        <div className="nova-breadcrumb-header-clean">
            <button 
                className="nova-breadcrumb-trigger-clean"
                onClick={() => setIsOpen(!isOpen)}
                title="Seleccionar catálogo"
            >
                <span 
                    className="nova-breadcrumb-icon-clean"
                    style={{ backgroundColor: currentCatalogo.color }}
                >
                    {currentCatalogo.icon}
                </span>
                <span className="nova-breadcrumb-text-clean">{currentCatalogo.label}</span>
                <FontAwesomeIcon icon={faChevronDown} className="nova-arrow-clean" />
            </button>
            {isOpen && (
                <div className="nova-breadcrumb-dropdown-clean">
                    {catalogos.map((catalogo) => (
                        <button
                            key={catalogo.path}
                            className={`nova-dropdown-item-clean ${currentPath.includes(catalogo.path) ? 'active' : ''}`}
                            onClick={() => {
                                navigate(catalogo.path);
                                setIsOpen(false);
                            }}
                        >
                            <span 
                                className="nova-item-badge-clean"
                                style={{ backgroundColor: catalogo.color }}
                            >
                                {catalogo.icon}
                            </span>
                            <span className="nova-item-label-clean">{catalogo.label}</span>
                            {currentPath.includes(catalogo.path) && (
                                <FontAwesomeIcon icon={faCheck} className="nova-item-check-clean" />
                            )}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BreadcrumbCatalogos;